<template>
  <v-row>
    <v-col cols="12">
      <v-card>
        <v-toolbar
          dark
          color="primary"
        >
          <v-btn
            color="primary"
            :to="'/customer'"
          >
            <mdi-close-circle />
            Annuler
          </v-btn>&emsp;
          <v-toolbar-title color="white">
            Enregistrer un nouveau client
          </v-toolbar-title>
        </v-toolbar>
        <v-container>
          <v-stepper v-model="e2">
            <v-stepper-header>
              <v-stepper-step
                :complete="e2 > 1"
                step="1"
              >
                Informations personnel
              </v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step
                :complete="e2 > 2"
                step="2"
              >
                Informations supplémentaire
              </v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step step="3">
                Resumé
              </v-stepper-step>
            </v-stepper-header>
            <v-form
              class="multi-col-validation"
            >
              <v-stepper-items>
                <v-stepper-content step="1">
                  <v-row style="margin-top: 1%;">
                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-select
                        v-model="customer.cust_sexe"
                        dense
                        :items="['M.', 'Mme', 'Mle']"
                        label="Civilité*"
                        outlined
                      ></v-select>
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-text-field
                        v-model="customer.cust_lastname"
                        dense
                        required
                        hide-details
                        label="Nom(s)*"
                        outlined
                        placeholder="Nom"
                      ></v-text-field>
                    </v-col>

                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-text-field
                        v-model="customer.cust_firstname"
                        dense
                        hide-details
                        required
                        label="Prénom(s)*"
                        outlined
                        placeholder="Prénom"
                      ></v-text-field>
                    </v-col>

                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-text-field
                        v-model="customer.cust_birthday"
                        dense
                        type="date"
                        hide-details
                        label="Date d'anniversaire*"
                        outlined
                        placeholder="date de naissance"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-text-field
                        v-model="customer.cust_birth_place"
                        dense
                        hide-details
                        label="Lieu de Naissance*"
                        outlined
                        placeholder="lieu de Naissance"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-select
                        v-model="customer.cust_type_id"
                        dense
                        :items="CustomerIdType"
                        label="Type de piece d'identité*"
                        outlined
                      ></v-select>
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-text-field
                        v-model="customer.cust_reference_id"
                        dense
                        hide-details
                        label="Référence de la pièce"
                        outlined
                        placeholder="Reference"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-text-field
                        v-model="customer.cust_id_expiration_date"
                        type="date"
                        dense
                        hide-details
                        label="Date d'expiration de la pièce*"
                        outlined
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-text-field
                        v-model="customer.cust_contact"
                        dense
                        hide-details
                        label="Contact*"
                        outlined
                        placeholder="numéro de telephone"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-text-field
                        v-model="customer.cust_place_residence"
                        dense
                        hide-details
                        label="Lieu de residence*"
                        outlined
                        placeholder="Domicile"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-btn
                        style="margin-left:1rem;margin-right: 1rem;"
                        color="primary"
                        @click="stepOnValidator()"
                      >
                        Continuer
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-stepper-content>

                <v-stepper-content step="2">
                  <v-row>
                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-text-field
                        v-model="customer.cust_mother_name"
                        dense
                        hide-details
                        label="Non de la mère"
                        outlined
                        placeholder="Non complet"
                      ></v-text-field>
                    </v-col>

                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-text-field
                        v-model="customer.cust_father_name"
                        dense
                        hide-details
                        label="Non du père "
                        outlined
                        placeholder="Nom complet"
                      ></v-text-field>
                    </v-col>

                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-text-field
                        v-model="customer.cust_job"
                        dense
                        hide-details
                        label="Profession*"
                        outlined
                        placeholder="metier"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-text-field
                        v-model="customer.cust_pseudonym"
                        dense
                        hide-details
                        label="Pseudonyme"
                        outlined
                        placeholder="nom de caresse"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-autocomplete
                        v-model="customer.cust_nationality"
                        dense
                        :item-text="'name'"
                        :item-value="'id'"
                        :items="Nationality"
                        label="Nationalité*"
                        deletable-chips
                        filled
                        outlined
                      ></v-autocomplete>
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-autocomplete
                        v-model="customer.cust_city"
                        dense
                        :items="CountryRegion"
                        :item-text="'name'"
                        :item-value="'id'"
                        label="Ville*"
                        deletable-chips
                        filled
                        outlined
                      ></v-autocomplete>
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-autocomplete
                        v-model="customer.cust_country"
                        dense
                        :item-text="item => item[4]"
                        :item-value="item => item[4]"
                        :items="countryWorld"
                        label="Pays*"
                        deletable-chips
                        filled
                        outlined
                      ></v-autocomplete>
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-text-field
                        v-model="customer.cust_date_of_entering_ivory_coast"
                        type="date"
                        dense
                        hide-details
                        label="Date d'entrée en cote d'ivoire"
                        outlined
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-text-field
                        v-model="customer.cust_email"
                        type="email"
                        dense
                        label="Adresse Email"
                        outlined
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-btn
                        color="primary"
                        @click="e2 = 1"
                      >
                        Precedent
                      </v-btn>
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-btn
                        style="margin-left:1rem;margin-right: 1rem;"
                        color="primary"
                        @click="stepTwoValidator()"
                      >
                        Continuer
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-stepper-content>

                <v-stepper-content step="3">
                  <v-row style="margin-top: 3%;">
                    <v-col
                      cols="12"
                      md="12"
                    >
                      <v-toolbar-title>Resumé</v-toolbar-title>
                    </v-col>
                  </v-row>
                  <v-row align-content-md="center">
                    <v-col
                      cols="12"
                      md="6"
                    >
                      Resumé des infos du client:  <br>
                      <p><span>Date Anniversaire</span> :<strong>{{ customer.cust_birthday }}</strong></p>
                      <p><span>Lieu de Naissance</span> :<strong>{{ customer.cust_birth_place }}</strong></p>
                      <p><span>Nom du père</span> :<strong>{{ customer.cust_father_name }}</strong></p>
                      <p><span>Nom de la mère</span> :<strong>{{ customer.cust_mother_name }}</strong></p>
                      <p><span>Nom de caresse</span> :<strong>{{ customer.cust_pseudonym }}</strong></p>
                      <p><span>Pays</span> :<strong>{{ customer.cust_country }}</strong></p>
                      <p><span>Ville</span> :<strong>{{ customer.cust_city }}</strong></p>
                      <p><span>Date d'expiration de la pièce</span> :<strong>{{ customer.cust_id_expiration_date }}</strong></p>
                      <p><span>Référence de la piece</span> :<strong>{{ customer.cust_reference_id }}</strong></p>

                      <p><span>Date d'entré en cote d'Ivoire</span> :<strong>{{ customer.cust_date_of_entering_ivory_coast }}</strong></p>
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                    >
                      Resumé des infos du client:  <br>
                      <p><span>Civilité</span> :<strong>{{ customer.cust_sexe }}</strong></p>
                      <p><span>Nom(s)</span> :<strong>{{ customer.cust_lastname }}</strong></p>
                      <p><span>Prénom(s)</span> :<strong>{{ customer.cust_firstname }}</strong></p>
                      <p><span>Nationalité</span> :<strong>{{ customer.cust_nationality }}</strong></p>
                      <p><span>Contact</span> :<strong>{{ customer.cust_contact }}</strong></p>
                      <p><span>Piece</span> :<strong>{{ customer.cust_type_id }}</strong></p>
                      <p><span>Email</span> :<strong>{{ customer.cust_email }}</strong></p>
                      <p><span>Profession</span> :<strong>{{ customer.cust_job }}</strong></p>
                      <p><span>Domicile</span> :<strong>{{ customer.cust_place_residence }}</strong></p>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-btn
                        color="primary"
                        @click="e2 = 2"
                      >
                        Precedent
                      </v-btn>
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-btn
                        style="margin-left:1rem;margin-right: 1rem;"
                        color="primary"
                        @click="newCustomer"
                      >
                        Valider
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-stepper-content>
              </v-stepper-items>
            </v-form>
          </v-stepper>
        </v-container>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mdiCloseCircle } from '@mdi/js'
import { VToolbar, VToolbarTitle } from 'vuetify'
import countryWorld from '../../assets/countryWorld'
import Nationality from '../../assets/Nationality'
import CustomerIdType from '../../assets/CustomerIdType'
import CountryRegion from '../../assets/CountryRegion'
import Customer from './CustomerModel'

export default {
  name: 'CustomerRegister',
  components: { VToolbarTitle, VToolbar },
  setup() {
    return {
      mdiCloseCircle,
      countryWorld,
      Nationality,
      CountryRegion,
      CustomerIdType,
    }
  },
  data() {
    return {
      e2: 1,
      customer: Customer,
    }
  },
  methods: {
    stepOnValidator() {
      const hasError = (this.customer.cust_sexe.length <= 0
         || this.customer.cust_lastname.length < 2
         || this.customer.cust_firstname.length < 2
         || this.customer.cust_birthday.length < 5
         || this.customer.cust_birth_place < 2
         || this.customer.cust_type_id < 3
         || this.customer.cust_reference_id < 9
         || this.customer.cust_id_expiration_date < 5
         || this.customer.cust_contact < 9
         || this.customer.cust_place_residence < 2)
      if (hasError) {
        this.$swal.fire({
          icon: 'error',
          title: 'Veuillez remplir correctement tout les champs',
          showConfirmButton: true,
          confirmButtonColor: '#C11E1F',
          confirmButtonText: 'Compris',
        })
      } else {
        this.e2 = 2
      }
    },
    stepTwoValidator() {
      const hasError = (this.customer.cust_job.length < 3
          || this.customer.cust_nationality.length < 3
          || this.customer.cust_country.length < 3
          || this.customer.cust_city.length < 3)
      if (hasError) {
        this.$swal.fire({
          icon: 'error',
          title: 'Veuillez remplir correctement tout les champs obligatoire',
          showConfirmButton: true,
          confirmButtonColor: '#C11E1F',
          confirmButtonText: 'Compris',
        })
      } else {
        this.e2 = 3
      }
    },
    newCustomer() {
      if (this.customer.cust_id_expiration_date === '') {
        this.customer.cust_id_expiration_date = null
      }
      this.customer.autoRegist = false
      this.$axios.post(this.$endpoint.CreateCustomer, this.customer).then(() => {
        this.e1 = 1
        this.customer = Customer
        this.$router.push('/customer')
      })
    },
  },
}
</script>

<style scoped>

</style>
